import SessionStorage from "../LocalCaching/SessionStorage";

export default function checkAdminLevel() {
  const adminLevel = SessionStorage.getCacheItem("admin_level");
  return adminLevel;
}
